import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import FJAIAudioItem from '../view/FJAIAudioItem.jsx';
import FJActionAIAudioGenerator from '../../../../redux/action/FJActionAIAudioGenerator.js';
import FJActionCommon from '../../../../redux/action/FJActionCommon.js';
import FJActionModal from '../../../../redux/action/FJActionModal.js';
import { setSliceSelectListAction } from '../../../../redux/slices/FJSliceCommon.js';
import FJConstant from '../../../../constants/FJConstant.js';
import { useState } from 'react';
import FJAudioPlayManager from '../../../../store/FJAudioPlayManager.js';
import PropTypes from 'prop-types';
import FJDropDownManager from '../../../../common/js/FJDropDownManager.js';

const FJAIAudioItemContainer = props => {
    useLocalStore();
    const dispatch = useDispatch();
    const { item } = props;
    const { status, audioName, audioUrl, id, coverUrl, audioWaveImgUrl, audioWavePlayImgUrl, audioTagType } = item;
    const selectList = useSelector(state => state.common.selectList);
    const isMultipleMode = useSelector(state => state.AIAudioGenerator.isMultipleMode);

    const selected = !!selectList?.find(i => i === id);
    const [editStatus, setEditStatus] = useState(FJConstant.SUCCESS);
    const [downloadStatus, setDownloadStatus] = useState(FJConstant.SUCCESS);

    const onSelect = () => {
        dispatch(FJActionAIAudioGenerator.setIsMultipleModeAction(true));
        dispatch(setSliceSelectListAction([id]));
    };

    const onSelected = (id, bool) => {
        if (bool) {
            dispatch(setSliceSelectListAction([...selectList, id]));
        } else {
            dispatch(setSliceSelectListAction(selectList.filter(i => i !== id)));
        }
    };

    const onRetry = e => {
        e.stopPropagation();
        dispatch(FJActionAIAudioGenerator.retryAIAudioAction(item));
    };
    const onDelete = e => {
        e.stopPropagation();
        FJDropDownManager.hideTopLevelDropDown();
        dispatch(FJActionCommon.multiDeleteAction([id]));
    };
    const onEdit = e => {
        e.stopPropagation();
        dispatch(
            FJActionModal.addAsEditPageAction([id], status => {
                setEditStatus(status);
            }),
        );
    };

    const _addToMediaLibrary = () => {
        dispatch(FJActionAIAudioGenerator.addToMediaLibraryAction([id]));
    };

    const download = e => {
        e.stopPropagation();
        setDownloadStatus(FJConstant.LOADING);
        dispatch(
            FJActionCommon.multiDownloadAction([id], undefined, () => {
                setDownloadStatus(FJConstant.SUCCESS);
            }),
        );
    };

    const preview = () => {
        if (isMultipleMode && (status === 'completed' || status === 'failed')) {
            onSelected(id, !selected);
            return;
        }
        if (status === 'completed') {
            dispatch(FJActionModal.showPreviewModalDataAction({ data: item }));
            FJAudioPlayManager.pauseAll();
        }
    };

    return (
        <FJAIAudioItem
            status={status}
            audioName={audioName}
            audioUrl={audioUrl}
            coverUrl={coverUrl}
            onRetry={onRetry}
            onDelete={onDelete}
            onEdit={onEdit}
            addToMediaLibrary={_addToMediaLibrary}
            download={download}
            preview={preview}
            isMultipleMode={isMultipleMode}
            onSelected={onSelected}
            selected={selected}
            editStatus={editStatus}
            downloadStatus={downloadStatus}
            id={id}
            audioWaveImgUrl={audioWaveImgUrl}
            audioWavePlayImgUrl={audioWavePlayImgUrl}
            audioTagType={audioTagType}
            onSelect={onSelect}
        />
    );
};

FJAIAudioItemContainer.propTypes = {
    item: PropTypes.object,
};
export default FJAIAudioItemContainer;
